import React from "react";
import { ReactComponent as FooterLogo } from "../assets/images/footer/footer-logo.svg";
import { ReactComponent as FbLogo } from "../assets/images/footer/fb-logo.svg";
import { ReactComponent as MLogo } from "../assets/images/footer/m-logo.svg";
import { ReactComponent as Twitter } from "../assets/images/footer/twitter-logo.svg";
import { ReactComponent as LinkedinLogo } from "../assets/images/footer/linkedin-logo.svg";
import { ReactComponent as AdressImg } from "../assets/images/footer/adress-img.svg";
import { ReactComponent as EmailImg } from "../assets/images/footer/email-img.svg";
import { ReactComponent as CapteraLogo } from "../assets/images/footer/capterra-logo.svg";
import { ReactComponent as GetAppLogo } from "../assets/images/footer/get-app-logo.svg";
import { ReactComponent as Point } from "../assets/images/footer/footer-point.svg";

const Footer = () => {
  return (
      <div className="footer mt-5">
        <div className="container container-xxl text-center mt-5">
          <div className="row">
            <div className="col-md-2 text-left" style={{ textAlign: "left" }}>
              <a href={"https://www.textunited.com/"}>
                <FooterLogo />
              </a>
              <div className="text-right mt-3">
                <div className="col-md-2"></div>
                <div className="socialIcons">
                  <a>
                    <FbLogo />
                  </a>
                </div>
                <div className="socialIcons">
                  <a>
                    <MLogo />
                  </a>
                </div>
                <div className="socialIcons">
                  <a>
                    <LinkedinLogo />
                  </a>
                </div>
                <div className="socialIcons">
                  <a>
                    <Twitter />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-3">
                  <div className="titleFooter">Company</div>
                  <div className="menuItem">
                    <a href={"https://www.textunited.com/contact-us/"}>Contact</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href={"https://www.textunited.com/blog/"}>Blog</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href={"https://www.textunited.com/case-studies/"}>Case Studies</a>
                  </div>

                  <div className="titleFooter pt-5">Resources</div>
                  <div className="menuItem">
                    <a href="https://api.textunited.com/index.html">API</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/pricing">Pricing</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/json-free-translator/">Free tools</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/my/signup/translator/">Register as a Translator</a>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="titleFooter">
                    <a href="https://www.textunited.com/solutions/" className="footer-title-link">
                      Solutions
                    </a>
                  </div>
                  <div className="menuItem">
                    <a href="https://www.textunited.com/solutions/website-translation/">Website Translation</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/solutions/elearning-education/">eLearning &amp; Education</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/solutions/software-localization/">Software Localization</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/solutions/unlock-new-markets/">Unlock New Markets</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/solutions/multilingual-customer-experience/">Multilingual Customer Experience</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/technology/translation-software/">Organisation &amp; Productivity of Translation</a>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="titleFooter">
                    <a href="https://www.textunited.com/technology/" className="footer-title-link">
                      Technology
                    </a>
                  </div>
                  <div className="menuItem">
                    <a href="https://www.textunited.com/technology/translation-software/">Translation Software</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/technology/transcription-subtitling/">Video Subtitles &amp; Transcriptions</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/technology/artificial-intelligence-machine-translation/">AI &amp; Machine Translation</a>
                  </div>
                  <div className="menuItem topBorder">
                    <a href="https://www.textunited.com/integrations/">Integrations &amp; Connectors</a>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="g2-badge-footer" style={{ maxWidth: "100px" }}>
                        <a href="https://www.g2.com/products/textunited/reviews" target="_blank">
                          <img
                              style={{ maxWidth: "100px" }}
                              src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/03/gq-performance-badge.webp"
                              alt="High performer - Localization"
                              data-src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/03/gq-performance-badge.webp"
                              decoding="async"
                              className=" ls-is-cached lazyloaded"
                          />
                          <noscript>
                            <img src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/03/gq-performance-badge.webp" alt="High performer - Localization" data-eio="l" />
                          </noscript>
                        </a>
                        <p className="badge-text">
                          <b>Localization</b>
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="g2-badge-footer" style={{ maxWidth: "100px" }}>
                        <a href="https://www.g2.com/products/textunited/reviews" target="_blank">
                          <img
                              style={{ maxWidth: "100px" }}
                              src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/03/gq-performance-badge.webp"
                              alt="High performer - Computer Assisted Translation"
                              data-src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/03/gq-performance-badge.webp"
                              decoding="async"
                              className=" ls-is-cached lazyloaded"
                          />
                          <noscript>
                            <img src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/03/gq-performance-badge.webp" alt="High performer - Computer Assisted Translation" data-eio="l" />
                          </noscript>
                        </a>
                        <p className="badge-text">
                          <b>Computer Assisted Translation</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="titleFooter">Contact Us</div>
                  <div className="row">
                    <div className="col-3" style={{ display: "inline-block" }}>
                      <img
                          style={{ textAlign: "left" }}
                          src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/09/Vector-4.png"
                          alt="direction icon"
                          data-src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/09/Vector-4.png"
                          decoding="async"
                          className=" ls-is-cached lazyloaded"
                      />
                      <noscript>
                        <img style={{ textAlign: "left" }} src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/09/Vector-4.png" alt="direction icon" data-eio="l" />
                      </noscript>
                    </div>
                    <div className="col-9 font15" style={{ textAlign: "left", fontSize: "15px" }}>
                      Attemsgasse 7/D/20 1220 – Vienna Austria
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-3" style={{ display: "inline-block" }}>
                      <img
                          style={{ textAlign: "left" }}
                          src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/envelop.png"
                          alt="envelop icon"
                          data-src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/envelop.png"
                          decoding="async"
                          className=" lazyloaded"
                      />
                      <noscript>
                        <img style={{ textAlign: "left" }} src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/envelop.png" alt="envelop icon" data-eio="l" />
                      </noscript>
                    </div>
                    <div className="col-9 font15" style={{ textAlign: "left", fontSize: "15px" }}>
                      servus@textunited.com
                    </div>
                  </div>
                  <div className="row text-center" style={{ marginTop: "5rem" }}>
                    <a href="https://www.textunited.com/ISO-17100-certification-enterprise-translation-services" target="_blank">
                      <img
                          src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/05/Tuv_Certificate150x150.webp"
                          alt="TUV certficate"
                          data-src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/05/Tuv_Certificate150x150.webp"
                          decoding="async"
                          className=" lazyloaded"
                      />
                      <noscript>
                        <img src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2022/05/Tuv_Certificate150x150.webp" alt="TUV certficate" data-eio="l" />
                      </noscript>
                    </a>
                  </div>
                  <div className="row mt-2">
                    <a href="https://www.capterra.com/p/151882/Text-United-Software/reviews/" target="_blank">
                      <div className="caterraBox">
                        <img
                            src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/Group-28.svg"
                            alt="Capterra user review image"
                            style={{ width: "170px" }}
                            data-src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/Group-28.svg"
                            decoding="async"
                            className=" lazyloaded"
                        />
                        <noscript>
                          <img src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/Group-28.svg" alt="Capterra user review image" style={{ width: "170px" }} data-eio="l" />
                        </noscript>
                      </div>
                    </a>
                  </div>
                  <div className="row mt-2">
                    <a href="https://www.getapp.com/website-ecommerce-software/a/text-united/" target="_blank">
                      <div className="caterraBox">
                        <img
                            src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/Group-29.svg"
                            alt="GetApp user review image"
                            style={{ width: "170px" }}
                            data-src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/Group-29.svg"
                            decoding="async"
                            className=" lazyloaded"
                        />
                        <noscript>
                          <img src="https://k6b8q4d6.rocketcdn.me/wp-content/uploads/2021/11/Group-29.svg" alt="GetApp user review image" style={{ width: "170px" }} data-eio="l" />
                        </noscript>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyrights" style={{ background: "#ECEEF2", marginTop: "86px" }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <p style={{ color: "#304254", padding: "16px", marginBottom: "unset", opacity: "0.6", fontSize: "15px", float: "left" }}>2023 TextUnited GmbH /All Rights Reserved</p>
              </div>
              <div className="col-md-4">
                <p style={{ color: "#304254", padding: "16px", marginBottom: "unset" }}>
                  <a className="bottomLinks" href="https://www.textunited.com/privacy-policy/">
                    Privacy Policy
                  </a>
                  <a className="bottomLinks" href="https://www.textunited.com/terms-conditions/">
                    {" "}
                    T&amp;Cs
                  </a>
                  <a className="bottomLinks" href="https://www.textunited.com/legal-notice/">
                    Legal Notice
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Footer;
